import { render, staticRenderFns } from "./wxbind.vue?vue&type=template&id=7d71e45c"
import script from "./wxbind.vue?vue&type=script&lang=js"
export * from "./wxbind.vue?vue&type=script&lang=js"
import style0 from "./wxbind.vue?vue&type=style&index=0&id=7d71e45c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports